module.exports = __webpack_public_path__ + "static/media/resume.5d06ac13.pdf";